import TopNCompaniesSelectionItem from "app/pages/sales-intelligence/sub-modules/company-search/models/table-actions-panel/TopNCompaniesSelectionItem";
import TopNWebsitesSelectionItem from "app/pages/sales-intelligence/sub-modules/company-search/models/table-actions-panel/TopNWebsitesSelectionItem";
import { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";

export const topNItemMap = {
    [LeadsType.Companies]: TopNCompaniesSelectionItem,
    [LeadsType.Websites]: TopNWebsitesSelectionItem,
};
